import { Box, Grid, Typography } from '@mui/material';

interface WorkerInfoCardProps {
    name: string;
    surname: string;
    cuil: string;
    workPosition: string;
    sector: string;
    handleDeleteClick: any;
    translate: (key: string) => string;
}

const WorkerInfoCard = ({
    name,
    surname,
    cuil,
    workPosition,
    sector,
    translate
}: WorkerInfoCardProps) => (
    <Box
        sx={{
            backgroundColor: '#F3F8F8',
            borderRadius: '8px',
            padding: '16px'
        }}
    >
        <Grid container justifyContent={'space-between'} alignItems={'flex-start'}>
            <Grid container direction={'row'} alignItems={'center'} gap={1}>
                <Typography variant="subtitle1">{`${name || ''} ${surname || ''}`}</Typography>
                <Typography pt={.5} variant="body1">{`${cuil || '-'}`}</Typography>
            </Grid>
        </Grid>
        <Typography variant="body1">{`${workPosition || '-'} - ${sector || '-'}`}</Typography>
    </Box>
);

export { WorkerInfoCard };
